import React, { memo, useCallback, useState } from "react";
import Slider from "react-slick";
import classNames from "classnames";

import "./styles.scss";

export const PRESETS = "PRESETS";
export const BANNER = "BANNER";
export const BANNER_MOBILE = "BANNER_MOBILE";

const classNameDic = {
  PRESETS: "preset",
  BANNER: "banner__desktop",
  BANNER_MOBILE: "banner__mobile",
};

const DefaultSlider = ({
  type,
  extraProps = {},
  itemClassName = null,
  containerClassName = null,
  onSelectSuggestion = null,
  unavailable,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...extraProps,
  };
  const [ presetItems ] = useState(new Array(type === PRESETS ? 30 : 3).fill(null));

  const onSelect = useCallback((index) => onSelectSuggestion(index), [onSelectSuggestion]);

  const renderImage = useCallback((index) => {
    const imageExtraProps = {
      ...(!onSelectSuggestion ? {} : { onClick: () => onSelect(index) }),
    };

    if (type === PRESETS) {
      const classes = classNames(`Slider__slide Slider__slide__${classNameDic[type]} Slider__slide__${classNameDic[type]}-${index}`, {
        disabled: unavailable.includes(index),
      });
      return (
        <div className={!itemClassName ? "" : itemClassName}>
          <div
            {...imageExtraProps}
            className={classes}
          />
        </div>
      )
    }

    return (
      <div className={!itemClassName ? "" : itemClassName}>
        <div
          {...extraProps}
          className={`Slider__slide Slider__slide__${classNameDic[type]}-${index}`}
        />
      </div>
    );
  }, [onSelectSuggestion, onSelect, unavailable, itemClassName]);

  const renderSlides = useCallback(() => {
    return presetItems.map((_, index) => {
      return (
        <div key={index} className="Slide">
          {renderImage(index)}
        </div>
      );
    });
  }, [presetItems, renderImage, onSelectSuggestion, onSelect, unavailable, itemClassName]);

  return (
    <Slider
      {...settings}
      className={`Slider StrapProductSliderMobile ${containerClassName &&
        containerClassName}`}
    >
      {renderSlides()}
    </Slider>
  );
};

export default memo(DefaultSlider);
